module.exports = __webpack_public_path__ + "static/media/logo-bonus.f4c973f7.svg";